import Service from "../../../../../utils/api/service";
import Media from "./../../../../../components/share/media";
import Multiselect from "vue-multiselect";
import _debounce from "lodash.debounce";

export default {
  name: "EditSubcategory",
  data() {
    return {
      isUpdating: false,
      display: {
        imagePreview: false,
        media: false,
      },
      body: {
        image: {
          file: "",
          presign: "",
        },
      },
      data: {},
      loading: {
        isCreating: false,
        isSearching: false,
      },
      brands: [],
      brandIds: [],
      items: this.$master?.brands || [],
      allItems: this.$master?.brands || [],
      debouncedOnSearchItems: null,
    };
  },
  components: {
    Media,
    Multiselect,
  },
  computed: {},
  created() {
    this.debouncedOnSearchItems = _debounce(this.handleItemsSearchChange, 500);
    this.getCategoryDetail(this.$route.query.id);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "EditCategory",
        query: { id: this.data.parentId },
      });
    },

    handleItemsSearchChange(query) {
      if (!query || query.trim() === "") {
        this.items = [...this.allItems];
        return;
      }

      this.filterItems(this.allItems, query);
    },

    filterItems(data, search) {
      if (!search || search.trim() === "") {
        this.items = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.items = items;
    },

    getCategoryDetail(id) {
      Service.getSubCategoryDetail(id).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCategoryDetail(id);
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data = response.data || {};
          this.brandIds = response?.data?.brands || [];
        }
      });
    },

    imagePreview() {
      if (this.data.imageUrl || (this.data.media && this.data.media.url)) {
        this.display.imagePreview = true;
      }
    },

    closeModal() {
      this.display = {
        imagePreview: false,
        media: false,
      };
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    chooseImage() {
      this.display.media = true;
    },

    existedMediaCallback(media) {
      this.data.media = media;
      this.data.imageUrl = this.data.media.url;
      this.closeModal();
    },

    newMediaCallBack(file) {
      this.body.image.file = file;
      this.closeModal();
    },

    submitUpdate() {
      let validatedMessage = this.validateBody(this.data);
      if (validatedMessage == "ok") {
        this.isUpdating = true;
        if (this.body.image.file) {
          this.uploadPresign();
        } else {
          this.updateCategory();
        }
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      // else if (this.brandIds && !this.brandIds.length) {
      //   return "Brand cannot be empty!";
      // }

      if (!data.imageUrl) {
        return "Image file cannot be empty!";
      } else if (!data.name) {
        return "Name cannot be empty!";
      } else if (!data.nameKh) {
        return "Name KH cannot be empty!";
      } else if (!data.subId) {
        return "Name cannot be empty!";
      } else if (!data.sortOrder) {
        return "Sort order cannot be empty!";
      } else if (!data.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    uploadPresign() {
      let body = {
        media: [
          {
            ext: this.body.image.file.type.split("/").pop(),
            type: "category",
            filename: this.body.image.file.name,
          },
        ],
      };
      Service.uploadPresign(body).then((response) => {
        this.body.image.presign = response.data;
        this.uploadFile(this.body.image.file);
      });
    },

    async uploadFile(file) {
      if (file) {
        let uploadUrl = this.body.image.presign[0].uploadUrl;
        await Service.uploadMedia(uploadUrl, file, file.type).then(
          (response) => {
            if (response == "ok") {
              this.updateCategory();
              this.addMedia();
            } else {
              this.$toasted.show("File upload fail!");
            }
          }
        );
      } else {
        this.$toasted.show("File cannot be empty!");
      }
    },

    addMedia() {
      let file = this.body.image.file;
      let body = {
        fileName: file.name,
        url: this.body.image.presign ? this.body.image.presign[0].key : "",
        type: file.type.split("/")[0],
        folder: "catelog",
        status: "active",
      };

      Service.addMedia(body);
    },

    updateCategory() {
      let id = this.data.id;
      if (this.body.image.file) {
        this.data.imageUrl = this.body.image.presign
          ? this.body.image.presign[0].key
          : "";
      } else if (this.data.media) {
        this.data.imageUrl = this.data.media.url;
      }

      let body = {
        name: this.data.name,
        nameKh: this.data.nameKh,
        imageUrl: this.data.imageUrl,
        sortOrder: this.data.sortOrder,
        subId: parseInt(this.data.subId),
        status: this.data.status,
        brandIds: this.brandIds.map((item) => item.id),
      };

      Service.updateCategory(id, body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.updateCategory();
              }
            });
          } else {
            this.isUpdating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isUpdating = false;
          this.$toasted.show("Subcategory has been updated.");
          this.goBack();
        }
      });
    },
  },
};
